import { Suspense, useEffect } from 'react';
import { TrackingEvents, useTrackingDispatch } from 'modules/analytics';
import { Layout } from 'modules/minimal-ui-theme';
import {
  LazyAddReasonErrorAlert,
  LazyAddReasonModal,
  LazyAddReasonSuccessToast,
  LazyAddShiftErrorAlert,
  LazyAddShiftModal,
  LazyAddShiftSuccessToast,
  LazyCloseWeekErrorAlert,
  LazyCloseWeekModal,
  LazyCloseWeekSuccessToast,
  LazyDeleteReasonSuccessToast,
  LazyDeleteShiftSuccessToast
} from 'modules/modals';
import { WeekDetails, WeekDetailsHeader } from 'modules/week-details';

export const WeekDetailsPage = () => {
  const dispatch = useTrackingDispatch();

  useEffect(() => {
    dispatch({
      type: TrackingEvents.WEEK_DETAILS_PAGE_VIEWED
    });
  }, [dispatch]);

  return (
    <Layout header={<WeekDetailsHeader />} withFooter>
      <WeekDetails />
      <Suspense>
        <LazyAddShiftErrorAlert />
        <LazyAddShiftModal />
        <LazyAddShiftSuccessToast />
        <LazyAddReasonSuccessToast />
        <LazyAddReasonErrorAlert />
        <LazyCloseWeekModal />
        <LazyCloseWeekSuccessToast />
        <LazyCloseWeekErrorAlert />
        <LazyAddReasonModal />
        <LazyDeleteShiftSuccessToast />
        <LazyDeleteReasonSuccessToast />
      </Suspense>
    </Layout>
  );
};
